import React from 'react';
import PropTypes from 'prop-types';
import BidsMakeAndModelProvider from './make-and-model-provider';
import AddBidLineModal, {
  MakeModelModalDataType,
} from './add-makes-and-models-modal';

const AddBidLineModalWrapper = ({
  isOpen,
  onClose,
  initialData = { siData: [] },
  modalTitle,
}) => {
  return (
    <BidsMakeAndModelProvider initialData={initialData}>
      <AddBidLineModal
        isOpen={isOpen}
        initialData={initialData}
        onClose={onClose}
        modalTitle={modalTitle}
      />
    </BidsMakeAndModelProvider>
  );
};

AddBidLineModalWrapper.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  initialData: MakeModelModalDataType,
  modalTitle: PropTypes.string,
};

export default AddBidLineModalWrapper;
